'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Home, AlertTriangle, ArrowRight } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from '@/context/I18nContext';

// Generate system ID lazily using a function
const generateSystemId = () => Math.random().toString(36).substring(7).toUpperCase();
export default function NotFound() {
  const $ = _c(85);
  const {
    t
  } = useTranslation();
  const [systemId] = useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="p-3 bg-red-500/10 rounded-lg border border-red-500/20"><AlertTriangle className="h-8 w-8 text-red-500" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("notFound.errorCode");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h1 className="text-4xl font-bold text-white tracking-tighter" suppressHydrationWarning={true}>{t1}</h1>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("notFound.errorTitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="text-sm text-gray-500 uppercase tracking-widest" suppressHydrationWarning={true}>{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-4 border-b border-gray-800 pb-6">{t0}<div>{t2}{t4}</div></div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex gap-2 absolute top-4 right-4 opacity-50"><div className="w-2.5 h-2.5 rounded-full bg-red-500/50" /><div className="w-2.5 h-2.5 rounded-full bg-yellow-500/50" /><div className="w-2.5 h-2.5 rounded-full bg-green-500/50" /></div>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-emerald-500">➜</span>;
    t8 = <span className="text-blue-400">~</span>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("notFound.rootCauseAnalysis");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <div className="flex gap-2">{t7}{t8}<span className="text-gray-400" suppressHydrationWarning={true}>{t9}</span></div>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-emerald-500">➜</span>;
    t12 = <span className="text-blue-400">~</span>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t11 = $[19];
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("notFound.routeScanning");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <div className="flex gap-2">{t11}{t12}<span className="text-gray-400" suppressHydrationWarning={true}>{t13}</span></div>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="text-red-500">➜</span>;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t) {
    t16 = t("notFound.error");
    $[26] = t;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16) {
    t17 = <span className="text-red-500 font-bold" suppressHydrationWarning={true}>{t16}</span>;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t) {
    t18 = t("notFound.errorMessage");
    $[30] = t;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t18) {
    t19 = <span className="text-gray-300" suppressHydrationWarning={true}>{t18}</span>;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t19) {
    t20 = <div className="flex gap-2 animate-pulse">{t15}{t17}{t19}</div>;
    $[34] = t17;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="text-yellow-500">➜</span>;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t) {
    t22 = t("notFound.warning");
    $[38] = t;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t22) {
    t23 = <span className="text-yellow-500" suppressHydrationWarning={true}>{t22}</span>;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t) {
    t24 = t("notFound.warningMessage");
    $[42] = t;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t24) {
    t25 = <span className="text-gray-400" suppressHydrationWarning={true}>{t24}</span>;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t23 || $[47] !== t25) {
    t26 = <div className="flex gap-2 pt-2">{t21}{t23}{t25}</div>;
    $[46] = t23;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <span className="text-emerald-500">➜</span>;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t) {
    t28 = t("notFound.suggestion");
    $[50] = t;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t28) {
    t29 = <span className="text-emerald-500" suppressHydrationWarning={true}>{t28}</span>;
    $[52] = t28;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t) {
    t30 = t("notFound.suggestionMessage");
    $[54] = t;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t30) {
    t31 = <span className="text-gray-300" suppressHydrationWarning={true}>{t30}</span>;
    $[56] = t30;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== t29 || $[59] !== t31) {
    t32 = <div className="flex gap-2 pt-2 border-t border-gray-800 mt-4">{t27}{t29}{t31}</div>;
    $[58] = t29;
    $[59] = t31;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== t10 || $[62] !== t14 || $[63] !== t20 || $[64] !== t26 || $[65] !== t32) {
    t33 = <div className="bg-black/50 rounded-xl border border-gray-800 p-6 shadow-2xl relative overflow-hidden group">{t6}<div className="space-y-3 text-sm">{t10}{t14}{t20}{t26}{t32}</div></div>;
    $[61] = t10;
    $[62] = t14;
    $[63] = t20;
    $[64] = t26;
    $[65] = t32;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Home className="h-4 w-4 group-hover:-translate-y-0.5 transition-transform" />;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== t) {
    t35 = t("notFound.backToHome");
    $[68] = t;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== t35) {
    t36 = <span suppressHydrationWarning={true}>{t35}</span>;
    $[70] = t35;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <ArrowRight className="h-4 w-4 opacity-50 group-hover:translate-x-1 transition-transform" />;
    $[72] = t37;
  } else {
    t37 = $[72];
  }
  let t38;
  if ($[73] !== t36) {
    t38 = <div className="flex justify-center pt-4"><Link href="/" className="group flex items-center gap-3 bg-white text-black px-6 py-3 rounded-lg font-bold text-sm hover:bg-gray-200 transition-all active:scale-95">{t34}{t36}{t37}</Link></div>;
    $[73] = t36;
    $[74] = t38;
  } else {
    t38 = $[74];
  }
  let t39;
  if ($[75] !== t) {
    t39 = t("common.systemId");
    $[75] = t;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] !== systemId || $[78] !== t39) {
    t40 = <div className="text-center"><p className="text-[10px] text-gray-700 uppercase tracking-widest" suppressHydrationWarning={true}>{t39}: {systemId}</p></div>;
    $[77] = systemId;
    $[78] = t39;
    $[79] = t40;
  } else {
    t40 = $[79];
  }
  let t41;
  if ($[80] !== t33 || $[81] !== t38 || $[82] !== t40 || $[83] !== t5) {
    t41 = <div className="min-h-screen flex flex-col items-center justify-center bg-[#0F1115] text-gray-300 p-6 font-mono selection:bg-red-500/30"><div className="max-w-lg w-full space-y-8">{t5}{t33}{t38}{t40}</div></div>;
    $[80] = t33;
    $[81] = t38;
    $[82] = t40;
    $[83] = t5;
    $[84] = t41;
  } else {
    t41 = $[84];
  }
  return t41;
}
function _temp() {
  return generateSystemId();
}